import api from '@/api/config/_api_config.js'

export default{

    login(data){
        const promise = api().post('/login',data)
        return promise.then((response) => response.data)
    }
}